// The player URL for a help video's YouTube link, or null for anything else.
// It loads from YouTube's privacy-enhanced domain (#1077): the privacy policy says we
// don't track visitors, and a help page only ever loads the player once the reader
// presses Play (see HelpVideo). `autoplay` is for that moment, so the press that loads
// the player also starts it. YouTube is the one video host the policy names, so other
// hosts are not played.
const YOUTUBE_ID = /^[\w-]{11}$/;

// "90", "90s", "1m30s", "1h2m3s" -> seconds; anything else -> null.
function seconds(t: string | null): number | null {
  if (!t) return null;
  if (/^\d+$/.test(t)) return Number(t);
  const m = /^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/.exec(t);
  if (!m || !(m[1] || m[2] || m[3])) return null;
  return Number(m[1] || 0) * 3600 + Number(m[2] || 0) * 60 + Number(m[3] || 0);
}

export function toEmbedUrl(src: string, opts: { autoplay?: boolean } = {}): string | null {
  let url: URL;
  try { url = new URL(src); } catch { return null; }

  let id: string | null = null;
  if (url.hostname === 'youtu.be') {
    id = url.pathname.slice(1).split('/')[0];
  } else if (/(^|\.)youtube(-nocookie)?\.com$/.test(url.hostname)) {
    id = url.pathname.includes('/embed/')
      ? url.pathname.split('/embed/')[1].split('/')[0]
      : url.searchParams.get('v');
  }
  // "videoseries" is a playlist embed: eleven characters, but no video.
  if (!id || !YOUTUBE_ID.test(id) || id === 'videoseries') return null;

  // rel=0 keeps the end screen to our own channel's videos.
  const params = new URLSearchParams({ rel: '0' });
  const start = seconds(url.searchParams.get('start') ?? url.searchParams.get('t'));
  if (start) params.set('start', String(start));
  if (opts.autoplay) params.set('autoplay', '1');
  return `https://www.youtube-nocookie.com/embed/${id}?${params}`;
}
